import React from "react";
import "./index.css";

// Static imports for pages (include .tsx extensions)
import Home from "./pages/home/index.tsx";
import Help from "./pages/Help.tsx";
import Gallery from "./pages/Gallery.tsx";
import Legal from "./pages/Legal.tsx";
import Status from "./pages/Status.tsx";
import LoginPage from "./pages/Login.tsx";
import LoginCallback from "./pages/LoginCallback.tsx";
import Integrations from "./pages/integrations/index.tsx";
import NodeDetail from "./pages/integrations/[nodeId]/index.tsx";

// Error handling and notifications
import { ErrorBoundary } from "./components/common/index.ts";
import { Toaster } from "sonner";

// Real backend API

// Note: this file expects `react-router-dom` to be installed.
import { BrowserRouter, Routes, Route } from "react-router-dom";

export function App() {
  return (
    <ErrorBoundary showErrorDetails={process.env.NODE_ENV === 'development'}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/help/*" element={<Help />} />
          <Route path="/gallery/*" element={<Gallery />} />
          <Route path="/legal/*" element={<Legal />} />
          <Route path="/status" element={<Status />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/integrations/:nodeId" element={<NodeDetail />} />
          <Route path="*" element={<Home />} />
        </Routes>
        {/* Toast notifications */}
        <Toaster 
          position="top-right" 
          expand={false}
          richColors
          closeButton
          toastOptions={{
            style: {
              background: 'hsl(var(--background))',
              color: 'hsl(var(--foreground))',
              border: '1px solid hsl(var(--border))',
            },
          }}
        />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;